import { TranslationsType } from "@/app/translations/Translations";

export const T_ForgotPassword: TranslationsType = {
  FORGOT_PASSWORD: {
    EN_US: "Forgot your password?",
    FR_FR: "Mot de passe oublié ?",
  },
  FORGOT_PASSWORD_TITLE: {
    EN_US: "Forgot your password?",
    FR_FR: "Mot de passe oublié ?",
  },
  FORGOT_PASSWORD_ACTION: {
    EN_US: "Send reset link",
    FR_FR: "Envoyer le lien",
  },
  RESET_PASSWORD_TITLE: {
    EN_US: "Reset your password",
    FR_FR: "Réinitialiser votre mot de passe",
  },
  RESET_PASSWORD_EMAIL_SENT: {
    EN_US: "A reset link has been sent to your email address.",
    FR_FR: "Un lien de réinitialisation a été envoyé à votre adresse e-mail.",
  },
  BACK_TO_LOGIN: {
    EN_US: "Back to login",
    FR_FR: "Retour à la connexion",
  },
};
